import { useState } from "react";
import { Lock, Mail, ArrowRight } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_fitsmith-academy/artifacts/zbh0gz3y_291E0B11-36FD-4420-BAF1-DDEC0FEFC105.png";
const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const r = await fetch(`${API}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });
      if (!r.ok) {
        let msg = "Ongeldige inloggegevens";
        try { const d = await r.json(); if (d.detail) msg = d.detail; } catch {}
        throw new Error(msg);
      }
      const data = await r.json();
      localStorage.setItem("fitsmith_admin_token", data.token);
      onLogin({ ...data.user, token: data.token });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="FitSmith" className="h-12 w-12 mx-auto mb-3 object-contain" />
          <h1 className="text-xl font-bold text-white">Admin Paneel</h1>
          <p className="text-zinc-500 text-sm mt-1">FitSmith Beheer</p>
        </div>
        <div className="course-card p-7">
          <form onSubmit={handleSubmit} data-testid="admin-login-form" className="space-y-3">
            <div>
              <label className="course-label">E-mailadres</label>
              <div className="relative">
                <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-600" />
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                  data-testid="admin-login-email" placeholder="admin@fitsmith.nl"
                  className="course-input pl-9" />
              </div>
            </div>
            <div>
              <label className="course-label">Wachtwoord</label>
              <div className="relative">
                <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-600" />
                <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                  data-testid="admin-login-password" placeholder="••••••••"
                  className="course-input pl-9" />
              </div>
            </div>
            {error && <p data-testid="admin-login-error" className="text-red-400 text-sm">{error}</p>}
            <button type="submit" disabled={loading} data-testid="admin-login-submit"
              className="btn-gold-course w-full py-3 font-bold text-sm uppercase tracking-wide">
              {loading ? "Bezig..." : <span className="flex items-center justify-center gap-2">Inloggen <ArrowRight size={13} /></span>}
            </button>
          </form>
        </div>
        <p className="text-center mt-4">
          <a href="/" className="text-zinc-600 text-xs hover:text-[#C9A84C]">← Terug naar website</a>
        </p>
      </div>
    </div>
  );
}
